import { render } from "./SystemPhotos.vue?vue&type=template&id=54e20e28&scoped=true"
import script from "./SystemPhotos.vue?vue&type=script&lang=js"
export * from "./SystemPhotos.vue?vue&type=script&lang=js"

import "./SystemPhotos.vue?vue&type=style&index=0&id=54e20e28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e20e28"]])

export default __exports__